<i18n>
{
    "en": {},
    "ua": {},
    "ru": {}
}
</i18n>

<template>
  <popup912x616 :visible.sync="opened">
    <template slot="content">
      <el-container class="main-container">
        <el-main>
          <el-row>
            <el-col :span="12">
              <customer :customer="customer" />
            </el-col>
            <el-col
              :span="12"
              style="border-left: 1px outset; padding-left: 5px"
            >
              <customers-list
                v-if="opened && !customer_for_merge"
                :customer_for_merge.sync="customer_for_merge"
              />
              <div v-if="customer_for_merge && got">
                <customer :customer="customer_for_merge" />
                <br />
                <br />
                <br />
                <el-button-group>
                  <el-button
                    type="primary"
                    icon="el-icon-arrow-left"
                    @click="
                      $confirm('Realy want?')
                        .then(() => {
                          handleMerge();
                        })
                        .catch(() => {})
                    "
                    >Merge to {{ customer.name }}
                  </el-button>
                  <el-button type="cancel" @click="customer_for_merge = null"
                    >Back to list</el-button
                  >
                </el-button-group>
              </div>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </template>
  </popup912x616>
</template>

<script>
import Popup912x616 from "../../_snippets/popup/popup_912x616";
import { mapGetters } from "vuex";
import Customer from "./merge_elements/customer";
import CustomersList from "./merge_elements/customers_list";
import CustomerClass from "../../../store/classes/SharedCustomers";

export default {
  name: "merge_component",
  components: { CustomersList, Customer, Popup912x616 },
  props: ["merge_mode"],
  data() {
    return {
      opened: this.merge_mode,
      filter: "",
      customer_for_merge: null,
      got: false
    };
  },
  watch: {
    merge_mode(v) {
      this.opened = v;
    },
    opened(v) {
      if (v) {
        return;
      }
      this.$emit("update:merge_mode", false);
    },
    "customer_for_merge.uuid"(v) {
      this.$log("customer_for_merge.uuid", v);
      if (!v) {
        this.customer_for_merge = null;
        this.got = false;
        return;
      }
      this.$api.client.defaultClient
        .query({
          query: require("../../../graphql/customers/customer.graphql"),
          variables: { uuid: v }
        })
        .then(res => {
          this.$log(res);
          this.customer_for_merge = new CustomerClass(
            res.data.shared_customers
          );
          this.got = true;
        });
    }
  },
  methods: {
    handleMerge() {
      this.$notify.info("start merge");
      let vars = Object.assign(
        {},
        { merge: this.customer_for_merge },
        this.customer
      );
      this.$api
        .mutate({
          mutation: require("../../../graphql/customers/customer_save.graphql"),
          variables: vars
        })
        .then(res => {
          this.$api
            .query({
              query: require("../../../graphql/customers/customers_list.graphql")
            })
            .then(res => {
              this.customer_for_merge = null;
              this.got = false;
              this.$notify.success({
                title: "Success merge"
              });
            });
        })
        .catch(res => {
          this.$notify.error({
            title: "Merge ERROR!",
            message: "Something went wrong"
          });
        });
    }
  },
  computed: {
    ...mapGetters({
      customer: "shared_customers/customer"
    })
  }
};
</script>

<style scoped lang="stylus">
.el-container.main-container
    padding 40px 0 0
</style>
